import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const SPOTS_TAKEN = 71;
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[4.5rem] flex-col items-center rounded-2xl bg-cream-200/70 px-3 py-3 sm:w-20" data-id="element-27" data-mp="3duh0v14dyw9j">
      <span className="font-display text-3xl font-bold tabular-nums text-ember-500" data-id="element-28" data-mp="39rkdkx3wibz9">{value}</span>
      <span className="mt-1 text-[0.6rem] font-bold uppercase tracking-[0.14em] text-forest-700/60" data-id="element-29" data-mp="3nrd00g8ea61f">
        {label}
      </span>
    </div>;
}
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23 * 3600 + 57 * 60 + 10);
  return <section className="w-full bg-cream-100 px-6 pb-12 pt-4 sm:pb-14" aria-labelledby="cuenta-titulo" data-id="element-30" data-mp="3sjd6ysmvtz7i">
      <div className="mx-auto flex max-w-xl flex-col items-center text-center" data-id="element-31" data-mp="ad8img5qxuea">
        <span className="inline-flex items-center gap-2 rounded-full bg-cream-200 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-forest-700" data-id="element-32" data-mp="5ef6os63ybg8">
          <FlameIcon className="h-3.5 w-3.5 text-ember-500" aria-hidden="true" data-id="element-33" data-mp="1dnkr8bffea42" />
          Precio de lanzamiento · Cierra en
        </span>

        <h2 id="cuenta-titulo" className="mt-4 font-display text-3xl font-bold text-forest-800 sm:text-4xl" data-id="element-34" data-mp="1nk7baxzxgx51">
          Tu Aula Puede Estar Lista Hoy
        </h2>

        <div className="mt-6 flex justify-center gap-3" role="timer" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-35" data-mp="1sgxrdlbqfsqg">
          <TimeBlock value={hours} label="Horas" data-id="element-36" data-mp="21hvxqa9n8cc7" />
          <TimeBlock value={minutes} label="Min" data-id="element-37" data-mp="26bqb6vynnv2u" />
          <TimeBlock value={seconds} label="Seg" data-id="element-38" data-mp="26d1fcww0j4uh" />
        </div>

        <p className="mt-4 text-sm text-forest-700/65" data-id="element-39" data-mp="2b8gt7ou0t0qw">
          Después sube. No vuelve al precio de lanzamiento.
        </p>

        <div className="mt-6 w-full max-w-md text-left" data-id="element-40" data-mp="2g6s31zkbfb94">
          <div className="flex items-baseline justify-between text-xs font-semibold" data-id="element-41" data-mp="2kbhvfefrm7pa">
            <span className="text-forest-700/70" data-id="element-42" data-mp="l4x13tyzeio7">Cupos al precio de lanzamiento</span>
            <span className="text-ember-500" data-id="element-43" data-mp="g757mviouohw">{SPOTS_TAKEN}% tomados</span>
          </div>
          <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-cream-300" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={SPOTS_TAKEN} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-44" data-mp="txrvttqtovzq">
            <div className="h-full rounded-full bg-ember-500" style={{
            width: `${SPOTS_TAKEN}%`
          }} data-id="element-45" data-mp="yxmlxv2rxhjq" />
          </div>
          <p className="mt-2 text-center text-xs text-forest-700/60" data-id="element-46" data-mp="1cx5uuq3eswx3">Quedan pocos cupos disponibles.</p>
        </div>
      </div>
    </section>;
}